import { useCallback, useEffect, useState } from "react";

export type FavoriteType = "movie" | "short";

const STORAGE_KEY = "midnight-video-favorites";

interface FavoriteMap {
  movie: string[];
  short: string[];
}

const emptyMap: FavoriteMap = { movie: [], short: [] };

function readFavorites(): FavoriteMap {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyMap;
    const parsed = JSON.parse(raw) as Partial<FavoriteMap>;
    return {
      movie: Array.isArray(parsed.movie) ? parsed.movie : [],
      short: Array.isArray(parsed.short) ? parsed.short : [],
    };
  } catch {
    return emptyMap;
  }
}

function writeFavorites(map: FavoriteMap) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // 本地存储不可用时静默处理，仅影响演示收藏
  }
}

export function useFavorite(type: FavoriteType, id: string) {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const map = readFavorites();
    setIsFavorite(map[type].includes(id));
  }, [type, id]);

  const toggleFavorite = useCallback(() => {
    const map = readFavorites();
    const list = map[type];
    const nextList = list.includes(id) ? list.filter((item) => item !== id) : [...list, id];
    writeFavorites({ ...map, [type]: nextList });
    setIsFavorite(nextList.includes(id));
    return nextList.includes(id);
  }, [type, id]);

  return { isFavorite, toggleFavorite };
}